interface SidebarProps {
  children: React.ReactNode
}

export default function Sidebar({ children }: SidebarProps) {
  return (
    <div className="flex flex-col bg-white lg:bg-zinc-50 h-full">
      {children}
    </div>
  )
} 